import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';

export const APP_ROUTES: Routes = [
  // Página pública de marketing — no requiere autenticación
  {
    path: 'home',
    loadComponent: () => import('./features/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./features/landing/landing.component').then((m) => m.LandingComponent),
  },
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'mfa',
    loadComponent: () => import('./features/auth/mfa-challenge.component').then((m) => m.MfaChallengeComponent),
  },
  {
    path: 'app',
    canActivate: [authGuard],
    loadComponent: () => import('./layout/app.layout.component').then((m) => m.AppLayoutComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'tracking' },
      {
        path: 'back-office',
        canActivate: [roleGuard(['SUPER_ADMIN'])],
        loadChildren: () => import('./features/back-office/back-office.routes').then((m) => m.BACK_OFFICE_ROUTES),
      },
      {
        path: 'stations',
        canActivate: [roleGuard(['SUPER_ADMIN'])],
        loadChildren: () => import('./features/stations/stations.routes').then((m) => m.STATIONS_ROUTES),
      },
      {
        path: 'fleet',
        canActivate: [roleGuard(['ADMIN_FLEET', 'STANDARD_USER'])],
        loadChildren: () => import('./features/fleet/fleet.routes').then((m) => m.FLEET_ROUTES),
      },
      {
        path: 'tracking',
        loadChildren: () => import('./features/tracking/tracking.routes').then((m) => m.TRACKING_ROUTES),
      },
      {
        path: 'geofences',
        canActivate: [roleGuard(['SUPER_ADMIN', 'ADMIN_FLEET'])],
        loadChildren: () => import('./features/geofences/geofences.routes').then((m) => m.GEOFENCES_ROUTES),
      },
      {
        path: 'credit-rules',
        canActivate: [roleGuard(['ADMIN_FLEET'])],
        loadChildren: () => import('./features/credit-rules/credit-rules.routes').then((m) => m.CREDIT_RULES_ROUTES),
      },
      {
        path: 'transactions',
        loadChildren: () => import('./features/transactions/transactions.routes').then((m) => m.TRANSACTIONS_ROUTES),
      },
      { path: 'alerts', loadChildren: () => import('./features/alerts/alerts.routes').then((m) => m.ALERTS_ROUTES) },
      {
        path: 'reports',
        loadChildren: () => import('./features/reports/reports.routes').then((m) => m.REPORTS_ROUTES),
      },
      {
        path: 'station-portal',
        canActivate: [roleGuard(['STATION_BASIC'])],
        loadChildren: () =>
          import('./features/station-portal/station-portal.routes').then((m) => m.STATION_PORTAL_ROUTES),
      },
      {
        path: 'fiscal',
        canActivate: [roleGuard(['ADMIN_FLEET', 'SUPER_ADMIN'])],
        loadChildren: () => import('./features/fiscal/fiscal.routes').then((m) => m.FISCAL_ROUTES),
      },
      {
        path: 'audit',
        canActivate: [roleGuard(['SUPER_ADMIN', 'ADMIN_FLEET'])],
        loadChildren: () => import('./features/audit/audit.routes').then((m) => m.AUDIT_ROUTES),
      },
      {
        path: 'bulk-import',
        canActivate: [roleGuard(['ADMIN_FLEET'])],
        loadChildren: () => import('./features/bulk-import/bulk-import.routes').then((m) => m.BULK_IMPORT_ROUTES),
      },
      {
        path: 'privacy',
        canActivate: [roleGuard(['SUPER_ADMIN', 'ADMIN_FLEET'])],
        loadChildren: () => import('./features/privacy/privacy.routes').then((m) => m.PRIVACY_ROUTES),
      },
      {
        path: 'settings',
        loadChildren: () => import('./features/settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
      },
    ],
  },
  {
    path: 'not-found',
    loadComponent: () => import('./features/shared/not-found.component').then((m) => m.NotFoundComponent),
  },
  { path: '**', redirectTo: 'not-found' },
];
